import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { DomUtil } from '@root/shared'

import RESTRICTED_BG from './assets/restricted-stripes.inline.svg'

type Props = {
  iconSize: number
} & React.HTMLAttributes<HTMLDivElement>

export const CurrencyIconRestricted: React.FC<Props> = ({
  iconSize,
  ...props
}) => {
  const { t } = useTranslation()

  const shouldShowLabel = iconSize > 60

  return (
    <Root {...props}>
      {shouldShowLabel ? (
        <LabelContainer>
          <Label>{t('currency.logo.restricted')}</Label>
        </LabelContainer>
      ) : undefined}
    </Root>
  )
}

const Root = styled.div`
  position: relative;
  background-image: ${DomUtil.cssUrl(RESTRICTED_BG)};
  background-repeat: repeat;
  background-size: 78px 78px;
  background-position: center;
  height: 100%;
  width: 100%;
  border-radius: var(--currency-icon-border-radius);
  overflow: hidden;
`

const LabelContainer = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 22px;
  background: rgba(0, 0, 0, 0.35);

  display: grid;
  align-items: center;
  justify-content: center;
`

const Label = styled.div`
  color: var(--textA-11);
  text-align: center;
  font-size: 9px;
  font-weight: 500;
  line-height: 12px;
  text-transform: uppercase;
`
